(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maternity-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var wrappers = document.querySelectorAll('[data-video-id]');

    wrappers.forEach(function (wrapper) {
      var video = wrapper.querySelector('.maternity-video__player');
      var playBtn = wrapper.querySelector('.maternity-video__play-btn');

      if (!video || !playBtn) return;

      function hidePlayBtn() {
        playBtn.classList.add('is-hidden');
        playBtn.setAttribute('aria-label', 'Pause maternity product video');
      }

      function showPlayBtn() {
        playBtn.classList.remove('is-hidden');
        playBtn.setAttribute('aria-label', 'Play maternity product video');
      }

      // Handle custom play button click
      playBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        video.paused ? video.play() : video.pause();
      });

      // Sync button state with actual video state
      video.addEventListener('play', hidePlayBtn);
      video.addEventListener('pause', showPlayBtn);
      video.addEventListener('ended', showPlayBtn);

      // Initial state
      if (video.paused) {
        showPlayBtn();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-accessories-listing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('pg-acc-list')) return;

    var MOBILE_QUERY = '(max-width: 749px)';

    class PgAccList extends HTMLElement {
      connectedCallback() {
        this.cards = Array.prototype.slice.call(this.querySelectorAll('.pg-acc__card'));
        this.wrap = this.querySelector('.pg-acc__more');
        this.moreBtn = this.querySelector('[data-pg-acc-more]');
        this.lessBtn = this.querySelector('[data-pg-acc-less]');
        this.shownEl = this.querySelector('[data-pg-acc-shown]');
        this.totalEl = this.querySelector('[data-pg-acc-total]');
        this.step = this.toInt(this.dataset.step, 6);
        this.mq = window.matchMedia(MOBILE_QUERY);
        this.userExpanded = false;

        this.onMore = this.showMore.bind(this);
        this.onLess = this.showLess.bind(this);
        this.onMedia = this.onMediaChange.bind(this);

        if (this.moreBtn) this.moreBtn.addEventListener('click', this.onMore);
        if (this.lessBtn) this.lessBtn.addEventListener('click', this.onLess);
        this.listenMedia(true);

        if (this.totalEl) this.totalEl.textContent = this.cards.length;

        this.shown = this.initial();
        this.render(false);
        this.setAttribute('data-ready', '');
      }

      disconnectedCallback() {
        if (this.moreBtn) this.moreBtn.removeEventListener('click', this.onMore);
        if (this.lessBtn) this.lessBtn.removeEventListener('click', this.onLess);
        this.listenMedia(false);
        this.removeAttribute('data-ready');
      }

      toInt(value, fallback) {
        var n = parseInt(value, 10);
        return isNaN(n) || n < 1 ? fallback : n;
      }

      listenMedia(add) {
        if (!this.mq) return;
        if (this.mq.addEventListener) {
          this.mq[add ? 'addEventListener' : 'removeEventListener']('change', this.onMedia);
        } else if (this.mq.addListener) {
          this.mq[add ? 'addListener' : 'removeListener'](this.onMedia);
        }
      }

      initial() {
        var value = this.mq.matches ? this.dataset.initialMobile : this.dataset.initial;
        return Math.min(this.toInt(value, 6), this.cards.length);
      }

      render(animate) {
        var shown = this.shown;

        this.cards.forEach(function (card, i) {
          var visible = i < shown;
          if (visible && card.hidden && animate) card.classList.add('pg-acc__card--revealed');
          if (!visible) card.classList.remove('pg-acc__card--revealed');
          card.hidden = !visible;
        });

        var allShown = shown >= this.cards.length;
        if (this.moreBtn) this.moreBtn.hidden = allShown;
        if (this.lessBtn) this.lessBtn.hidden = !this.userExpanded;
        if (this.wrap) this.wrap.hidden = allShown && !this.userExpanded;
        if (this.shownEl) this.shownEl.textContent = shown;
      }

      showMore() {
        var first = this.shown;
        this.shown = Math.min(this.shown + this.step, this.cards.length);
        this.userExpanded = true;
        this.render(true);

        var link = this.cards[first] && this.cards[first].querySelector('.pg-acc__title');
        if (link) link.focus({ preventScroll: true });
      }

      showLess() {
        this.userExpanded = false;
        this.shown = this.initial();
        this.render(false);

        if (this.moreBtn) this.moreBtn.focus({ preventScroll: true });

        if (this.getBoundingClientRect().top < 0) {
          var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        }
      }

      onMediaChange() {
        if (this.userExpanded) return;
        this.shown = this.initial();
        this.render(false);
      }
    }

    customElements.define('pg-acc-list', PgAccList);
  })();

  } catch(e) { console.error(e); }
})();
})();
